/**
 * Site-wide FirstPromoter click tracking (`?fpr=` → `_fprom_tid` / `_fprom_ref`).
 * Account ID: Settings → Integrations. Skip when `NUXT_PUBLIC_FIRSTPROMOTER_CID` is empty.
 */
export default defineNuxtPlugin({
  name: 'firstpromoter',
  setup() {
    const cid = String(useRuntimeConfig().public?.firstPromoterCid || '').trim()
    if (!/^[A-Za-z0-9_-]+$/.test(cid)) return

    useHead({
      script: [
        {
          key: 'firstpromoter-init',
          innerHTML: `(function(w){w.fpr=w.fpr||function(){w.fpr.q=w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);fpr("init",{cid:"${cid}"});fpr("click");`,
        },
        {
          key: 'firstpromoter-cdn',
          src: 'https://cdn.firstpromoter.com/fpr.js',
          async: true,
        },
      ],
    })
  },
})
